<template>
    <button @click.prevent="shareFb" class="main-share-button">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 27" width="14px" height="27px">
            <path fill="#FFF" fill-rule="nonzero"
                  d="M9 27V15h4l1-5H9V8c0-2 1.002-3 3-3h2V0h-4C6.325 0 4 2.881 4 7v3H0v5h4v12h5z"/>
        </svg>
        <span>
        <slot></slot>
    </span>
    </button>
</template>

<script>
    import facebookShare from "../helpers/facebookShare";
    export default {
        props: {
            buttonName: {
                type: String,
                default: ''
            }
        },
        methods: {
            shareFb() {
                return facebookShare();
                // let w = 600;
                // let h = 800;
                // var left = screen.width / 2 - w / 2;
                // var top = screen.height / 2 - h / 2;
                // // window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width='+w+', height='+h+', top='+top+', left='+left);
                //
                // return window.open(
                //     "https://www.facebook.com/sharer/sharer.php?u=" +
                //     encodeURIComponent(location.href),
                //     "facebook-share-dialog",
                //     "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" +
                //     w + ", height=" + h + ", top=" + top + ", left=" + left
                // );
            }
        }
    }
</script>

<style>

</style>